import { useQuery } from '@tanstack/react-query';
import { WalletInstitution } from '../../interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

const getWalletInstitutions = async () => {
  const { data } = await api.get<WalletInstitutionsResponse>(
    apiConfig.routes.wallet.institutions
  );
  return data;
};

export const useGetWalletInstitutions = () => {
  return useQuery({
    queryKey: ['wallet', 'institutions'],
    queryFn: getWalletInstitutions,
    select: (data) => ({
      data,
      total: data.reduce((acc, item) => acc + item.total, 0),
    }),
  });
};

type WalletInstitutionsResponse = WalletInstitution[];
